<template>
  <div id="app">
    <router-view></router-view>
    <!-- <div class="service-hotline">
      <span>服务热线</span>
      <span>023-6503129</span>
    </div> -->
    <div class="side-ad" v-if="advertImage">
      <img :src="advertImage" alt="广告图片" @load="onImageLoad" @error="onImageError">
    </div>
    <div class="side-ad" v-else>
      <img src="@/assets/guanggao.png" alt="默认广告图片">
    </div>
  </div>
</template>

<script>
import { getLtCourseVideoDalist } from '@/api/website'

export default {
  name: 'App',
  data() {
    return {
      advertImage: null
    }
  },
  async mounted() {
    await this.fetchAdvertImage()
  },
  methods: {
    async fetchAdvertImage() {
      try {
        console.log('开始请求广告图片接口...')
        const response = await getLtCourseVideoDalist()
        console.log('接口返回数据:', response)
        
        if (response.rows && response.rows.length > 0) {
          const firstRow = response.rows[0]
          console.log('第一条数据:', firstRow)
          console.log('封面图片URL:', firstRow.cover)
          this.advertImage = firstRow.cover
        } else {
          console.warn('接口返回数据中rows为空或不存在')
        }
      } catch (error) {
        console.error('获取广告图片失败:', error)
        // 如果获取失败，保持默认图片
      }
    },
    onImageLoad() {
      console.log('广告图片加载成功:', this.advertImage)
    },
    onImageError() {
      console.error('广告图片加载失败:', this.advertImage)
      // 如果新图片加载失败，回退到默认图片
      this.advertImage = null
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.service-hotline {
  position: fixed;
  right: 20px;
  top: 15px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  color: #a75a41;
  cursor: default;
  font-weight: bold;
  gap: 4px;
}
.side-ad {
  position: fixed;
  right: 10px;
  top: 5px;
  z-index: 9999 !important;
  width: 150px;
  min-height: 200px;
  background-color: transparent;
  pointer-events: auto;
}
.side-ad img {
  max-width: 150px;
  width: 100%;
  height: auto;
  display: block;
  border: none;
  box-sizing: border-box;
  pointer-events: auto;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}
@media (max-width: 768px) {
  .side-ad {
    width: 100px;
    right: 5px;
  }
  .side-ad img {
    max-width: 100px;
  }
}
</style>